import {initState} from './initHelpers.js';

const stateNameSpace = 'observerTabNewFormState';

window[stateNameSpace] = {...initState()};

export function getGlobalState() {
  return window[stateNameSpace];
}

export function setGlobalState(newState) {
  window[stateNameSpace] = {...window[stateNameSpace], ...newState}
}
